const filtersButtons = Array.prototype.slice.call(
    document.querySelectorAll('[data-action="open-overlay"]')
);

const closeOverlayButtons = Array.prototype.slice.call(
    document.querySelectorAll('[data-action="close-overlay"]')
);

const openFilters = () => {
    document.body.classList.add('filtering');
    window.scrollTo(0, 0);
}

const closeFilters = () => {
    document.body.classList.remove('filtering');
}

export const attachEventListeners = () => {
    filtersButtons.forEach((button) => {
        button.addEventListener('click', openFilters);
    });

    closeOverlayButtons.forEach((button) => {
        button.addEventListener('click', closeFilters);
    });
}